<template>
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
          <path :fill="color" d="M2180 5104 c-169 -44 -333 -179 -408 -335 -59 -121 -75 -213 -70
          -406 3 -147 5 -161 28 -203 14 -24 45 -58 68 -75 40 -27 51 -30 122 -30 71 0
          82 3 122 30 23 17 54 51 68 75 23 42 25 58 30 215 6 189 12 211 75 263 20 16
          53 34 74 41 27 7 189 11 527 11 485 -1 489 -1 442 -19 -70 -28 -112 -57 -162
          -112 -54 -60 -92 -135 -106 -208 -6 -35 -10 -619 -10 -1667 l0 -1614 -326 0
          c-354 0 -379 3 -440 53 -69 57 -74 80 -74 361 0 270 -5 303 -52 361 -43 52
          -95 75 -168 75 -98 0 -174 -51 -205 -139 -22 -63 -22 -519 1 -629 48 -238 234
          -436 469 -497 48 -12 128 -15 427 -15 l368 0 0 -125 c0 -68 5 -148 11 -177 28
          -129 114 -240 234 -299 63 -31 78 -34 175 -37 l105 -3 687 230 c728 243 759
          256 829 340 16 20 44 65 62 101 l32 65 3 2019 c2 1842 1 2025 -14 2071 -36
          112 -120 205 -232 258 l-67 32 -1285 2 c-1093 2 -1293 0 -1340 -13z"/>
          <path :fill="color" d="M1216 4050 c-48 -15 -101 -58 -127 -103 -24 -42 -24 -42 -27 -394
          l-3 -353 -455 0 c-427 0 -457 -1 -492 -19 -81 -42 -115 -105 -110 -206 4 -91
          36 -142 111 -180 l51 -25 448 0 448 0 0 -331 c0 -220 4 -345 11 -370 15 -50
          62 -105 110 -129 51 -27 146 -27 197 -1 55 29 938 917 957 963 23 56 19 126
          -10 184 -18 37 -134 158 -467 490 -244 243 -458 449 -477 459 -40 20 -125 28
          -165 15z"/>
      </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#5a6b8e',
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/EntryIcon.vue